<template>
  <div>
    <div>
      <div class="is-flex is-flex-direction-column is-align-items-flex-end">
        <LinkEntity v-if="payload" :payload="{...payload, resource_type: additional_data.resource_type}" />
        <br />
        <br />
        <Message :payload="payload" :additional_data="additional_data" />
        <br />
        <br />
        <GhanaFlag v-if="isNewRegistartion" :payload="payload" />
      </div>
    </div>
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'
import Message from '@/components/Message'
export default {
  name: 'alert-linked-entity-with-message',
  props: ['payload', 'additional_data'],
  components: {
    LinkEntity,
    Message,
    GhanaFlag
  },
  computed: {
    isNewRegistartion () {
      if (!this.$route.query.designators) {
        return
      }
      return this.$route.query.designators.includes('new_registration') && this.additional_data.resource_type == 'Applicant'
    }
  }
}
</script>
